import _reducer from 'lodash/reduce';

// eslint-disable-next-line max-len
export const depthCalculator = (compatibilitySegments, getSkuProductDimensions) => (fullProductGroupNames, halfProductGroupNames, baseProductGroupsNames) => {
  let maxFullGroupDepth = 0;
  let maxHalfGroupDepth = 0;

  if (baseProductGroupsNames.length === 1) {
    const baseSKu = compatibilitySegments[baseProductGroupsNames[0]][0].Sku;
    const baseSKuDims = getSkuProductDimensions(baseSKu);
    maxFullGroupDepth = baseSKuDims?.depth;
  }

  if (fullProductGroupNames) {
    fullProductGroupNames.forEach((fullProductGroupName) => {
      const currentMaxFullGroupDepth = _reducer(compatibilitySegments[fullProductGroupName],
        (max, compatibilitySegment) => {
          const currentDepthDims = getSkuProductDimensions(compatibilitySegment.Sku);
          return (currentDepthDims?.depth > max) ? currentDepthDims?.depth : max;
        }, 0);
      maxFullGroupDepth = (currentMaxFullGroupDepth > maxFullGroupDepth)
        ? currentMaxFullGroupDepth : maxFullGroupDepth;
    });
  }

  if (halfProductGroupNames) {
    halfProductGroupNames.forEach((halfProductGroupName) => {
      const currentMaxGroupDepth = _reducer(compatibilitySegments[halfProductGroupName],
        (max, compatibilitySegment) => {
          const currentDepthDims = getSkuProductDimensions(compatibilitySegment.Sku);
          return (currentDepthDims?.depth > max) ? currentDepthDims?.depth : max;
        }, 0);
      maxHalfGroupDepth = currentMaxGroupDepth > maxHalfGroupDepth ? currentMaxGroupDepth : maxHalfGroupDepth;
    });
  }
  return (maxHalfGroupDepth > maxFullGroupDepth) ? maxHalfGroupDepth : maxFullGroupDepth;
};
